"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _posthogjs = require('posthog-js'); var _posthogjs2 = _interopRequireDefault(_posthogjs);

var _redactLinks = require('./redactLinks');




let hasInitialized = false

const hasKey = () => !!POSTHOG_PROJECT_TOKEN

const readParams = () => {
  if (typeof window === 'undefined') return new URLSearchParams()

  try {
    const params = new URLSearchParams(window.location.search)
    const [, hashQuery = ''] = window.location.hash.split('?')

    new URLSearchParams(hashQuery).forEach((value, key) => params.set(key, value))
    return params
  } catch (e) {
    return new URLSearchParams()
  }
}

const getBootstrap = () => {
  const params = readParams()
  const distinctID = params.get('distinct_id') || params.get('bt_ph_distinct_id') || undefined
  const sessionID = params.get('session_id') || params.get('bt_ph_session_id') || undefined

  return distinctID || sessionID
    ? { distinctID, sessionID }
    : undefined
}

const init = () => {
  if (!POSTHOG_PROJECT_TOKEN || hasInitialized) return

  try {
    _posthogjs2.default.init(POSTHOG_PROJECT_TOKEN, {
      api_host: POSTHOG_HOST || 'https://e.bloomtext.com',
      // api_host is a first-party reverse proxy; toolbar/app links must still
      // point at PostHog itself.
      ui_host: 'https://us.posthog.com',
      // Ad blockers match the capture URL's shape, not just its host: the live
      // uBlock rule is `/e/*^ip=*^compression=`, which needs BOTH params. The
      // SDK omits undefined query values, so disabling compression drops
      // `compression=` and the rule stops matching. Costs us gzip on the
      // request body. See TM-632.
      disable_compression: true,
      // We don't use dead-click capture. NOTE: this stops the capture but NOT
      // the asset fetch — remote config triggers the lazy load before this
      // flag is consulted, so `/static/dead-clicks-autocapture.js` is still
      // requested (and still blocked by a filter-list rule, despite PostHog
      // saying /static/ should not be blocked). Stopping the request needs the
      // project-level `capture_dead_clicks` setting. Verified 2026-08-20.
      capture_dead_clicks: false,
      capture_pageview: false,
      autocapture: false,
      disable_session_recording: true,
      persistence: 'localStorage+cookie',
      cross_subdomain_cookie: true,
      bootstrap: getBootstrap(),
      // Form and patient-link codes in the page URL open the form or the chat.
      before_send: _redactLinks.redactPostHogEvent,
    })
    hasInitialized = true
  } catch (e) {
    // Analytics must never block the app from loading.
  }
}

const capture = (
  event,
  properties,
  options



,
) => {
  if (!hasKey()) return
  init()
  try {
    // sendBeacon survives an immediate hard navigation (Stripe/Calendly
    // redirects); the default batched transport drops events queued right
    // before unload.
    _posthogjs2.default.capture(event, properties, options)
  } catch (e) {
    // Ignore analytics failures.
  }
}

const identify = (distinctId, properties) => {
  if (!hasKey() || !distinctId) return
  init()
  try {
    _posthogjs2.default.identify(distinctId, properties)
  } catch (e) {
    // Ignore analytics failures.
  }
}

const alias = (aliasId, originalId) => {
  if (!hasKey() || !aliasId) return
  init()
  try {
    _posthogjs2.default.alias(aliasId, originalId)
  } catch (e) {
    // Ignore analytics failures.
  }
}

const isSafeValue = (value) => (
  typeof value === 'string'
    || typeof value === 'number'
    || typeof value === 'boolean'
    || (Array.isArray(value) && value.every(v => typeof v === 'string'))
)

const sanitizeForKeys = (
  properties = {},
  allowedKeys,
) => {
  const output = {}

  allowedKeys.forEach(key => {
    const value = properties[key]
    if (isSafeValue(value)) output[key] = value
  })

  return output
}

const SAFE_GROUP_PROPERTY_KEYS = [
  'member_count',
  'features',
  'created_at',
]

const sanitizeGroupProperties = (properties) =>
  sanitizeForKeys(properties, SAFE_GROUP_PROPERTY_KEYS)

const group = (type, key, properties) => {
  if (!hasKey()) return
  init()
  try {
    _posthogjs2.default.group(type, key, sanitizeGroupProperties(properties))
  } catch (e) {
    // Analytics must never block the app from loading.
  }
}

const reset = () => {
  if (!hasKey()) return
  init()
  try {
    _posthogjs2.default.reset()
  } catch (e) {
    // Ignore analytics failures.
  }
}

// True when the current distinct id belongs to an identified person (a
// previous login), false for an anonymous/device lineage or on any failure.
const isIdentified = () => {
  if (!hasKey()) return false
  init()
  try {
    return _posthogjs2.default._isIdentified()
  } catch (e) {
    return false
  }
}

exports. default = {
  init,
  capture,
  identify,
  alias,
  group,
  reset,
  isIdentified,
}
